(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const NAV_ARROWS = 'arrows';
    const NAV_PAG = 'pagination';
    const CN_AUTOPLAY = '@autoplay';
    const SP_AUTOPLAY = '--autoplay';
    const ATTR_AUTOPLAY = 'autoplay';
    const CN_NAV_DISABLED = '!disabled';
    const SEL_BG_VIDEO = 'background-video';
    const SEL_VIDEO_SLIDE = '[data-video-slide]';
    const ATTR_HAS_VIDEO = 'has-video';
    const ATTR_NAVIGATION = 'navigation';
    const ATTR_AUTO_HEIGHT = 'auto-height';

    customElements.define('slideshow-hero', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            next: '[data-next]', // Custom next button
            prev: '[data-prev]'  // Custom previous button
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
            this._initAutoplay();
            this._initResponsiveMap(); // Initialize the responsive map
            this._addCustomNavListeners(); // Add custom event listeners for navigation buttons
        }

        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
            this.hasVideo && this.swiper.on('slideChange', () => {
                this._toggleVideo.bind(this);
                this._scaleImageMap(); // Adjust image map on slide change
            });
        }

        _setSwiperProps() {
            this.swiperProps = {
                loop: true,
                navigation: {
                    nextEl: this.elements.next, // Link the custom next button
                    prevEl: this.elements.prev, // Link the custom prev button
                    disabledClass: CN_NAV_DISABLED
                }
            };

            this.swiperProps.autoHeight = this.autoHeight;

            if (this.hasVideo)
                this.swiperProps.on = {
                    init: () => {
                        window.customElements.whenDefined(SEL_BG_VIDEO).then(() => {
                            this.videoSlides = Array.from(this.querySelectorAll(SEL_VIDEO_SLIDE)).map(video => {
                                video.querySelector(SEL_BG_VIDEO).initPlayer();
                                return video;
                            });
                            this._scaleImageMap(); // Ensure scaling on init
                        });
                    }
                }

            if (this.navigation === NAV_PAG)
                this.swiperProps.pagination = {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }

            if (this.autoplay)
                this.swiperProps.autoplay = {
                    delay: this.autoplay
                }
        }

        _addCustomNavListeners() {
            const nextBtn = this.querySelector(this.elements.next);
            const prevBtn = this.querySelector(this.elements.prev);

            if (nextBtn) {
                nextBtn.addEventListener('click', (event) => {
                    event.preventDefault(); // Prevent default anchor behavior
                    this.swiper.slideNext(); // Move to the next slide
                });
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', (event) => {
                    event.preventDefault(); // Prevent default anchor behavior
                    this.swiper.slidePrev(); // Move to the previous slide
                });
            }
        }

        _initAutoplay() {
            if (this.autoplay) {
                this.classList.add(CN_AUTOPLAY);
                this.style.setProperty(SP_AUTOPLAY, `${this.autoplay}ms`);
                this.swiper.on('autoplayStop', () => {
                    this.classList.remove(CN_AUTOPLAY);
                });
            }
        }

        _toggleVideo({ slides, activeIndex, previousIndex }) {
            const current = this.videoSlides.find((item) => item === slides[activeIndex]);
            const prev = this.videoSlides.find((item) => item === slides[previousIndex]);
            current?.querySelector(SEL_BG_VIDEO)?.play();
            prev?.querySelector(SEL_BG_VIDEO)?.pause();
        }

        _initResponsiveMap() {
            const originalWidth = 1898; // Original width of the image in pixels
            const originalHeight = 831; // Original height of the image in pixels
            const image = document.querySelector("img[usemap]"); // Find the image with the usemap attribute
            const map = document.querySelector(image?.useMap); // Find the associated map

            if (!image || !map) {
                console.error("Image or map element not found");
                return;
            }

            console.log("Responsive map initialized");

            function scaleImageMap() {
                // Ensure the image has fully loaded before measuring
                if (image.complete && image.naturalWidth !== 0) {
                    const currentWidth = image.clientWidth;
                    const currentHeight = image.clientHeight;

                    console.log("Scaling image map...");
                    console.log(`Current width: ${currentWidth}, Current height: ${currentHeight}`);

                    const widthRatio = currentWidth / originalWidth;
                    const heightRatio = currentHeight / originalHeight;

                    map.querySelectorAll("area").forEach(area => {
                        const originalCoords = area.dataset.originalCoords.split(",").map(Number);
                        const scaledCoords = originalCoords.map((coord, index) =>
                            index % 2 === 0 ? Math.round(coord * widthRatio) : Math.round(coord * heightRatio)
                        );
                        console.log(`Scaled coords for area: ${scaledCoords.join(",")}`);
                        area.coords = scaledCoords.join(",");
                    });
                } else {
                    console.warn("Image is not fully loaded yet. Retrying...");
                    setTimeout(scaleImageMap, 100); // Retry after a short delay
                }
            }

            // Store original coordinates as a data attribute
            map.querySelectorAll("area").forEach(area => {
                if (!area.dataset.originalCoords) {
                    area.dataset.originalCoords = area.coords;
                }
            });

            // Initial scaling on page load
            window.addEventListener("load", () => {
                console.log("Page loaded, scaling image map");
                scaleImageMap();
            });

            // Re-scale on window resize
            window.addEventListener("resize", scaleImageMap);
        }

        get navigation() {
            return this.getAttribute(ATTR_NAVIGATION);
        }
        get hasVideo() {
            return this.hasAttribute(ATTR_HAS_VIDEO);
        }
        get autoplay() {
            return this.getAttribute(ATTR_AUTOPLAY) && +this.getAttribute(ATTR_AUTOPLAY);
        }
        get autoHeight() {
            return this.hasAttribute(ATTR_AUTO_HEIGHT);
        }
    });
})();

